import { render, staticRenderFns } from "./RefundsList.vue?vue&type=template&id=209f1515&"
import script from "./RefundsList.vue?vue&type=script&lang=js&"
export * from "./RefundsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports